
import React, {Fragment} from 'react'
import Viewport from './element/viewport';
import Carrousel from './gallery/carrousel';
import Buttons from './element/buttons';

export default function PartGallery(props) {
    let part = props.part;
    let gallery_type = part['gallery_type'];
    return (
        <Fragment>
            {
                part['content'] &&
                    <div className="text">
                        <div dangerouslySetInnerHTML={{__html: part['content']}} />
                    </div>
            }
            {     
                props.part_buttons &&
                    <Buttons part_buttons={props.part_buttons} />
            }     
            {        
                part['media']['gallery'] &&
                        <Fragment>
                            {
                                gallery_type === 'mosaic' && 
                            
                                    <div className="gallery">
                                        <div className="thumbs wrap justify-center">
                                            {
                                                part['media']['gallery'].map(image => {
                                                    let image_style = { backgroundImage: `url(${image['path']})` }; //Resize 250x250
                                                    return <div className="thumb" style={image_style} data-url={image['path']} key={image['path']}>
                                                                <div className="lens"></div>
                                                            </div>
                                                })
                                            }
                                        </div>
                                        <Viewport />
                                    </div>
                                
                            }
                            {
                                gallery_type === 'carrousel' &&
                                    <Carrousel part={part} />
                            }
                        </Fragment>
            }
        </Fragment>
    )
}


